import React from 'react';
import { TotalSalesKPI, CustomerSatisfactionKPI, AverageInvoiceKPI, NewCustomersKPI, SubscriptionRateKPI, SmsChargeNegativeDaysKPI } from './kpis';
import { SectionProps } from '../../hooks/useMainPerformanceSections';

interface KPIsSectionProps extends SectionProps {
  branchId: number;
  timeRange?: string;
}

const KPIsSection: React.FC<KPIsSectionProps> = ({
  branchId,
  timeRange = 'last6Months',
  onError,
  showLoading = true,
  compact = false
}) => {
  return (
    <div className={`grid grid-cols-1  ${compact ? 'md:grid-cols-1' : 'md:grid-cols-1 lg:grid-cols-4'} gap-6 mb-6`}>
      <TotalSalesKPI 
        branchId={branchId} 
        timeRange={timeRange} 
        onError={onError}
        showLoading={showLoading}
        compact={compact}
      />
      
      <SubscriptionRateKPI 
        branchId={branchId} 
        timeRange={timeRange} 
        onError={onError}
        showLoading={showLoading}
        compact={compact}
      />

      <CustomerSatisfactionKPI 
        branchId={branchId} 
        timeRange={timeRange} 
        onError={onError}
        showLoading={showLoading}
        compact={compact}
      />


      <SmsChargeNegativeDaysKPI 
        branchId={branchId} 
        timeRange={timeRange} 
        onError={onError}
        showLoading={showLoading}
        compact={compact}
      />
    </div>
  );
};

export default KPIsSection;